export function mixHexColors(hex1: string, hex2: string): string {
  // Убираем символ # и конвертируем шестнадцатеричные значения в десятичные
  const color1 = hex1.startsWith("#") ? hex1.slice(1) : hex1;
  const color2 = hex2.startsWith("#") ? hex2.slice(1) : hex2;

  const r1 = parseInt(color1.slice(0, 2), 16);
  const g1 = parseInt(color1.slice(2, 4), 16);
  const b1 = parseInt(color1.slice(4, 6), 16);

  const r2 = parseInt(color2.slice(0, 2), 16);
  const g2 = parseInt(color2.slice(2, 4), 16);
  const b2 = parseInt(color2.slice(4, 6), 16);

  // Вычисляем 0.75 для каждого канала
  const rMix = Math.round((r1 + r2) * 0.75);
  const gMix = Math.round((g1 + g2) * 0.75);
  const bMix = Math.round((b1 + b2) * 0.75);

  // Конвертируем обратно в шестнадцатеричный формат и возвращаем
  return `#${toHex(rMix)}${toHex(gMix)}${toHex(bMix)}`;
}

// Вспомогательная функция для преобразования числа в шестнадцатеричное значение с ведущим нулём
function toHex(value: number): string {
  return value.toString(16).padStart(2, "0").toUpperCase();
}
